// extracted by mini-css-extract-plugin
export const sectionContactForm = "contactForm-module--sectionContactForm--3yEoE";
export const sectionContainer = "contactForm-module--sectionContainer--2Js_v";
export const sectionContent = "contactForm-module--sectionContent--Bt4no";
export const formWrapper = "contactForm-module--formWrapper--2jItC";
export const contentWrap = "contactForm-module--contentWrap--PnnG0";
export const contactNumber = "contactForm-module--contactNumber--vhM22";
export const socialLinks = "contactForm-module--socialLinks--1Gldg";
export const formEmail = "contactForm-module--formEmail--2-vjf";
export const formSubject = "contactForm-module--formSubject--1Jvv7";
export const formMessage = "contactForm-module--formMessage--3d0LV";
export const submitWrap = "contactForm-module--submitWrap--ZetHK";
export const formSubmit = "contactForm-module--formSubmit--2zXMJ";